import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import cart from './core/reducers/CartReducer';
import website from './core/reducers/WebsiteReducer';
import overlay from './core/reducers/OverlayReducer';
import config from './config/ConfigReducer';
import menu from './core/side-nav/hamburger/HamburgerNavReducer';
import sideNavigation from './core/side-nav/SideNavReducer';
import products from './products/reducers/ProductsReducer';
import productSettings from './products/reducers/ProductSettingsReducer';
import productSettingsTemplates from './products/reducers/ProductSettingsTemplatesReducer';
import newProduct from './products/reducers/new-product/NewProductReducer';
import creationSettings from './new-product/creation/reducers/CreationSettingsReducer';
import creationSettingsTemplates from './new-product/creation/reducers/CreationSettingsTemplatesReducer';
import toast from './core/reducers/ToastReducer';
import notification from './core/reducers/NotificationReducer';
import account from './account/reducers/AccountReducer';
import approvals from './approvals/reducers/ApprovalsReducer';
import accessories from './accessories/reducers/AccessoriesReducer';
import dashboard from './dashboard/reducers/DashboardReducer';
import { settingsPageSliceReducer as settings } from './settings/SettingsPage';
import { addressUploadReducer as addressUpload } from './bulk/AddressUpload';

const reducers = {
  config,
  menu,
  sideNavigation,
  products,
  productSettings,
  productSettingsTemplates,
  newProduct,
  creationSettings,
  creationSettingsTemplates,
  routing: routerReducer,
  toast,
  notification,
  cart,
  website,
  overlay,
  account,
  approvals,
  accessories,
  dashboard,
  settings,
  addressUpload,
};

export default combineReducers(reducers);
